import { SessionStore } from '/global-state/session';
import { UiStore } from '/global-state/ui';

import { PageTargetedAlerts } from '../../page-targeted-alerts';

import css from './style.module.scss';

type UiFlags = 'theme-light' | 'theme-dark' | 'side-nav-collapsed';

/**
 * Provides global UI elements (eg. page-targeted alerts) to any page, regardless of chrome.
 */
export function OuterChrome({ children }: { children: React.ReactNode }) {
  const sideNavCollapsed = UiStore.useState((s) => s.sideNavCollapsed);
  const theme = SessionStore.useState((s) => s.session?.user.settings.dashboard_navigation_theme) ?? 'light';

  const uiFlags: UiFlags[] = [];

  uiFlags.push(`theme-${theme}` as 'theme-light' | 'theme-dark');

  if (sideNavCollapsed) {
    uiFlags.push('side-nav-collapsed');
  }

  return (
    <div className={css.outerChrome + ' ' + uiFlags.map((flag) => `jw-dash-ui--${flag}`).join(' ')}>
      <PageTargetedAlerts />

      {children}
    </div>
  );
}
